import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";
import Button from "react-bootstrap-button-loader";
import { converDateIntoLocalwithmonth } from "Constants";
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

var Loader = require("react-loaders").Loader; // import "AwesomeLoaderCss";

class UsageHistorySubheader extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            isOpen: false,
        };
    }

    componentDidMount() {

    }

    //Arrow function for renderLoader

    render() {
        let { clientdataforbilling, eventData, total_accountusageCount } = this.props;
        // console.log('total_accountusageCount',total_accountusageCount)
        let validupto = '';
        let userlimit = 0;
        let userlimitcount = 0;
        let percentage = 0;

        if (clientdataforbilling && clientdataforbilling.length > 0) {
            validupto = converDateIntoLocalwithmonth(clientdataforbilling[0].validupto).format("D MMM YYYY");
            userlimit = clientdataforbilling[0].userlimit;
        }

        if (total_accountusageCount) {
            userlimitcount = userlimit - total_accountusageCount.count

        }
        percentage = parseInt(total_accountusageCount.count) / userlimit * 100;
        return (
            <div className="usagehistory-subheader">
                <div className="usage-subheaderbox">
                    <div className="usage-topheader">
                        <div className="" style={{ fontWeight: "600" }}>{LocaleStrings.accountsetting_usagehistory_subheader_usercredits}</div>
                        <div className="mt-2">{LocaleStrings.accountsetting_usagehistory_subheader_validuntill} {validupto}</div>
                    </div>
                    <hr style={{ margin: 0 }} />
                    {/* <div className="usage-middle">
                    <div className="usage-middle-subtext">{userlimitcount}</div>
                    </div> */}
                    <div className="row p-4" >
                        <div className="col-md-5" style={{ textAlign: 'center' }}>
                            <CircularProgressbar className="team-member-circularprogressbar" value={percentage} />
                        </div>
                        <div className="col-md-7" style={{ textAlign: 'start' }}>
                            <div className="d-flex">
                                <div style={{ fontWeight: "600" }}>{LocaleStrings.accountsetting_usagehistory_subheader_credits}</div>
                                <div style={{ marginLeft: 'auto', marginRight: '40px' }}>{userlimit}</div>
                            </div>
                            <div className="d-flex mt-2">
                                <div style={{ fontWeight: "600" }}>{LocaleStrings.accountsetting_usagehistory_subheader_used}</div>
                                <div style={{ marginLeft: 'auto', marginRight: '40px' }}>{total_accountusageCount.count}</div>
                            </div>
                            <div className="d-flex mt-2">
                                <div style={{ fontWeight: "600" }}>Remaining</div>
                                <div style={{ marginLeft: 'auto', marginRight: '40px' }}>{userlimitcount}</div>
                            </div>
                        </div>
                        {/* <div className="block" style={{textAlign:'center'}}>
                        <div className="flex">
                            <div>1</div>
                            <div>12</div>
                        </div>
                    </div> */}
                    </div>


                </div>


            </div>
        );
    }
}


function mapStateToProps(state) {
    var { session, user } = state;
    var eventData = {};
    if (state.eventData[0]) {
        eventData = state.eventData[0];
    }
    return {
        session,
        user,
        deviceSize: state.deviceSize,
        clientdataforbilling: state.clientdataforbilling,
        eventData,
        total_accountusageCount: state.total_accountusageCount
    };
}

export default connect(mapStateToProps, {})(UsageHistorySubheader);
